// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-price .uk-text-small>*{margin:0}.product-price .uk-text-muted{padding-right:.5rem}.product-price .uk-text-warning{text-decoration:line-through}.product-price .discount-expire{min-height:1.5rem}.anyday-pricetag-container anyday-price-widget{justify-content:center}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
